module.exports = "<country-page></country-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/country.html
// module id = 2136
// module chunks = 0